import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateLicenseMonthlyTrialSubForm = document.createElement('template');

templateLicenseMonthlyTrialSubForm.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='title' id='monthly-license-product-details-title'></gz-title>

    <section id='monthly-license-product-details'>
      <span class='module-info-text'>
        <span id='monthly-license-trial-product-details-license-info-text'></span>
      </span>
      <span class='module-info-text'>
        <span id='monthly-license-trial-product-delegate-details-license-info-text'></span>
      </span>
      <span class='module-info-text'>
        <span id='monthly-license-trial-product-details-endpoint-security-text'></span>
        <gz-link id='monthly-license-trial-product-details-endpoint-security-link' type='underline' color='primary'></gz-link>
      </span>
      <span class='module-info-text'>
        <span id='monthly-license-trial-product-details-bitdefender-edr-text'></span>
        <gz-link id='monthly-license-trial-product-details-bitdefender-edr-link' type='underline' color='primary'></gz-link>
      </span>
    </section>
  </div>
`;
